import z from 'zod';
export const CONTROL_KIND = {
    CHOICE: 'choice',
    DATE: 'date',
    TEXT: 'text',
};
export const contentControlTypeValue = z.enum([
    CONTROL_KIND.CHOICE,
    CONTROL_KIND.DATE,
    CONTROL_KIND.TEXT,
]);
export const contentControlType = (value) => contentControlTypeValue.parse(value);
export const isContentControlType = (value) => contentControlTypeValue.safeParse(value).success;
export const CONTENT_CONTROL_TYPES = [
    CONTROL_KIND.CHOICE,
    CONTROL_KIND.DATE,
    CONTROL_KIND.TEXT,
];
export const WORD_HIGHLIGHT_COLORS = {
    black: '#000000',
    blue: '#0000ff',
    cyan: '#00ffff',
    darkBlue: '#000080',
    darkCyan: '#008080',
    darkGray: '#808080',
    darkGreen: '#008000',
    darkMagenta: '#800080',
    darkRed: '#800000',
    darkYellow: '#808000',
    green: '#00ff00',
    lightGray: '#c0c0c0',
    magenta: '#ff00ff',
    red: '#ff0000',
    white: '#ffffff',
    yellow: '#ffff00',
};
const wordHighlightColorValues = Object.keys(WORD_HIGHLIGHT_COLORS);
export const wordHighlightColorValue = z.enum(wordHighlightColorValues);
export const wordHighlightColor = (value) => wordHighlightColorValue.parse(value);
export const isWordHighlightColor = (value) => value !== null
    && value !== undefined
    && wordHighlightColorValue.safeParse(value).success;
export { CLIENT_VARIABLE_MAPPING, clientDocxVariable, clientDocxVariableValue, isClientDocxVariable, } from './client-variable-mapping';
export { EMPLOYEE_GENDER_ACCORD_BY_DOCX_VARIABLE, EMPLOYEE_GRAMMATICAL_GENDER, employeeGenderAccordDocxVariable, employeeGenderAccordDocxVariableValue, isEmployeeGenderAccordDocxVariable, resolveEmployeeGenderAccordValue, resolveEmployeeGrammaticalGender, } from './employee-gender-accord-mapping';
export { EMPLOYEE_VARIABLE_MAPPING, employeeDocxVariable, employeeDocxVariableValue, isEmployeeDocxVariable, } from './employee-variable-mapping';
export { isLegalRepresentativeGenderAccordDocxVariable, LEGAL_REPRESENTATIVE_GENDER_ACCORD_BY_DOCX_VARIABLE, LEGAL_REPRESENTATIVE_GRAMMATICAL_GENDER, legalRepresentativeGenderAccordDocxVariable, legalRepresentativeGenderAccordDocxVariableValue, resolveLegalRepresentativeGenderAccordValue, resolveLegalRepresentativeGrammaticalGender, } from './legal-representative-gender-accord-mapping';
export { getStrapiFieldValueAtPath, isClientMappedEditorVariable, isEmployeeGenderAccordEditorVariable, isEmployeeMappedEditorVariable, resolveClientEditorVariableValues, resolveClientFieldPathForVariable, resolveEmployeeEditorVariableValues, resolveEmployeeFieldPathForVariable, } from './resolve-editor-variable-values';
export { applyWordThemeShade, applyWordThemeTint, mapWordThemeColorToPaletteSlot, normalizeWordTextColorHex, resolveWordTextColor, themeColorPaletteSchema, themeColorPaletteSlotValue, wordTextColorAttributesSchema, } from './word-text-color';
//# sourceMappingURL=index.js.map